import { createStore, applyMiddleware, compose } from 'redux';
import reducer from '../reducers';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import createSagaMiddleware from 'redux-saga';
import saga from '../sagas/saga';
import { ACTIONS as AUTH_ACTIONS } from '../containers/Auth/auth.actionTypes';
import { ACTIONS } from '../actions/actionTypes';
import history from './history';
const sagaMiddleware = createSagaMiddleware();

const middlewares = [];

const router = routerMiddleware(history);
middlewares.push(sagaMiddleware);
middlewares.push(thunk);
middlewares.push(router);

var store;
if (process.env.NODE_ENV === 'development') {
    const logger = createLogger({
        predicate: (getState, action) => ((action.type !== AUTH_ACTIONS.AUTH_INPUT_CHANGED) && (action.type !== ACTIONS.TICK_TIMER))
    });
    middlewares.push(logger);
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    store = composeEnhancers(applyMiddleware(...middlewares))(createStore)(reducer);
} else {
    store = compose(applyMiddleware(...middlewares))(createStore)(reducer);
}

export default store;
sagaMiddleware.run(saga);



// WEBPACK FOOTER //
// ./src/config/store.js